export enum ActionPointType {
    Indication,
    Continuity,
    Fidelity,
    Sale,
    AdvanceSale
}

export const toActionPointTypeString = (type: ActionPointType): string => {
    switch (type) {
        case ActionPointType.Continuity:
            return "Continuidad";
        case ActionPointType.Fidelity:
            return "Fidelidad";
        case ActionPointType.Indication:
            return "Indicacion";
        case ActionPointType.Sale:
            return "Niveles de venta";
        case ActionPointType.AdvanceSale:
            return "Ventas anticipadas"
        default: {
            return "[Unknown ActionPointType]";
        }
    }
};
    